import { createApp } from 'vue'
import './axios'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import i18n from './i18n';
//new css
import './externalStyles';

loadFonts()


const language = localStorage.getItem('lang') || 'en';
document.documentElement.setAttribute('dir', language === 'ar' ? 'rtl' : 'ltr');
document.documentElement.setAttribute('lang', language);
document.body.classList.toggle('is-rtl', language === 'ar');
document.body.classList.toggle('is-ltr', language !== 'ar');


createApp(App)
    .use(router)
    .use(i18n)
    .use(vuetify)
    .mount('#app')